"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = exports.configureNewRelic = exports.errorHandler = void 0;
const isTruthy_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isTruthy"));
const isBrowserSupported_1 = __importDefault(require("@simplisafe/ewok/supported-browsers/isBrowserSupported"));
const local_storage_1 = require("local-storage");
const monet_1 = require("monet");
const unless_1 = __importDefault(require("ramda/src/unless"));
const cookies_1 = require("../../cookies");
const errorHandler = (__err) => {
    const isSupported = (0, isBrowserSupported_1.default)(navigator.userAgent);
    // eslint-disable-next-line no-console
    (0, unless_1.default)(isTruthy_1.default, () => console.log('Error is not being reported since browser is unsupported.'))(isSupported);
    return isSupported;
};
exports.errorHandler = errorHandler;
const configureNewRelic = () => {
    typeof window !== 'undefined' && monet_1.Maybe.fromUndefined(window)
        .chain(_window => monet_1.Maybe.fromUndefined(_window.newrelic))
        .forEach(newrelic => newrelic.setErrorHandler(exports.errorHandler));
};
exports.configureNewRelic = configureNewRelic;
const logError = (error, details = {}, priority) => {
    // wrapping NODE_ENV in a Maybe because I'm unsure how to actually test it - setting it to null/undefined in a unit
    // test seems to just turn it into the string 'null' or 'undefined'
    // TODO: using NODE_ENV will always be 'production' for the built site. this should somehow pass along dev/qa/stg/production.
    const env = monet_1.Maybe.fromNull(process.env.NODE_ENV).orJust('unknown');
    const vid = (0, cookies_1.getVisitorId)();
    const drupalUid = (0, cookies_1.getUserId)();
    const atAtToken = (0, cookies_1.getAtAtToken)();
    const cartId = (0, local_storage_1.get)('cartId') || 'unknown';
    const errorCategory = details.errorCategory;
    const errorDetails = {
        ...details,
        atAtToken: atAtToken || '',
        cartId,
        drupalUid,
        environment: env,
        errorCategory,
        isCaught: 'true',
        isEcommData: 'true',
        priority: priority ? priority : errorCategory ? 'warning' : 'info',
        vid
    };
    // eslint-disable-next-line no-console
    console.error(error, details);
    // log the error and details to newrelic after checking if window and newrelic are defined
    typeof window !== 'undefined' && monet_1.Maybe.fromUndefined(window)
        .chain(_window => monet_1.Maybe.fromUndefined(_window.newrelic))
        .forEach(newrelic => newrelic.noticeError(error, errorDetails));
};
exports.logError = logError;
//# sourceMappingURL=index.js.map